export const UNDO_SEND_WINDOW_MS = 60 * 1000;

function safeString(v) {
  return typeof v === "string" ? v : v == null ? "" : String(v);
}

function timeMs(value) {
  const raw = safeString(value).trim();
  if (!raw) return null;
  const d = new Date(raw);
  return Number.isNaN(d.getTime()) ? null : d.getTime();
}

export function undoSendRemainingSeconds(createdAt, nowMs = Date.now()) {
  const createdMs = timeMs(createdAt);
  if (createdMs == null) return 0;

  const remainingMs = createdMs + UNDO_SEND_WINDOW_MS - Number(nowMs || 0);
  if (remainingMs <= 0) return 0;
  return Math.ceil(remainingMs / 1000);
}

export function canShowUndoSend({
  createdAt,
  ownerUserId,
  currentUserId,
  isRetracted = false,
  isReadOnly = false,
  isCanonical = true,
  nowMs = Date.now(),
} = {}) {
  const owner = safeString(ownerUserId).trim();
  const current = safeString(currentUserId).trim();

  return !!(
    isCanonical &&
    owner &&
    current &&
    owner === current &&
    !isRetracted &&
    !isReadOnly &&
    undoSendRemainingSeconds(createdAt, nowMs) > 0
  );
}
